import FileReader from './src/index.vue'

export default FileReader
